<script setup lang="ts">
import '@/utils/floorUtils.ts';

import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

import NumberRangeComponent from '@/components/filters/NumberRange.vue';
import type { LocaleSchema } from '@/locales/index';
import type { NumberRange } from '@/typings/NumberRange';

const props = defineProps<{
  maxValue: number,
  minValue: number
}>();

const modelValue = defineModel<NumberRange | undefined>();

const { t, locale } = useI18n<{ message: LocaleSchema }>({
  useScope: 'global',
});

function tooltipFormatter(value: number) {
  return value.toLocaleString(locale.value, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

watch(modelValue, (newValue) => {
  if (newValue?.min === props.minValue && newValue?.max === props.maxValue) {
    modelValue.value = undefined;
  }
}, { immediate: true });
</script>

<template>
  <fieldset>
    <legend>{{ t('forms.units.filters.livingArea.title') }}</legend>
    <p>{{ t('forms.units.filters.livingArea.subTitle') }}</p>
    <NumberRangeComponent v-model="modelValue"
                          allow-manual-inputs
                          :min-value="props.minValue"
                          :min-value-label="`${modelValue?.min ?? props.minValue} ${t('browsingApp.units.squareFeet')}`"
                          :max-value="props.maxValue"
                          :max-value-label="`${modelValue?.max ?? props.maxValue} ${t('browsingApp.units.squareFeet')}`"
                          :step="25"
                          :slider-format="tooltipFormatter"
                          integer />
  </fieldset>
</template>
